export interface ActivityActionTypes {
  type: ActivityActions;
  payload?: any;
}

export enum ActivityActions {
  CREATE_ACTIVITY = "CREATE_ACTIVITY",
  GET_ACTIVITY_LIST = "GET_ACTIVITY_LIST",
  SET_ACTIVITY_LIST = "SET_ACTIVITY_LIST",
  SET_ACTIVITY_LIST_PAGE_COUNT = "SET_ACTIVITY_LIST_PAGE_COUNT",
  GET_ACTIVITY_DATA_BY_ID = "GET_ACTIVITY_DATA_BY_ID",
  SET_ACTIVITY_DATA_BY_ID = "SET_ACTIVITY_DATA_BY_ID",
  EDIT_ACTIVITY_DATA_BY_ID = "EDIT_ACTIVITY_DATA_BY_ID",
  GET_MY_ACTIVITY_LIST = "GET_MY_ACTIVITY_LIST",
  SET_MY_ACTIVITY_LIST = "SET_MY_ACTIVITY_LIST",
  SET_MY_ACTIVITY_LIST_PAGE_COUNT = "SET_MY_ACTIVITY_LIST_PAGE_COUNT",
  GET_MY_ACTIVITY_BY_ID = "GET_MY_ACTIVITY_BY_ID",
  SET_MY_ACTIVITY_DATA = "SET_MY_ACTIVITY_DATA",
  EDIT_MY_ACTIVITY_BY_ID = "EDIT_MY_ACTIVITY_BY_ID",
}
